import { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Sector } from "recharts";

export interface DonutSeg { name: string; value: number; color: string; }

function ActiveShape(props: any) {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
  return (
    <Sector
      cx={cx} cy={cy} innerRadius={innerRadius} outerRadius={outerRadius + 5}
      startAngle={startAngle} endAngle={endAngle} fill={fill} cornerRadius={3}
    />
  );
}

export default function RiskDonut({
  segments, size = 160, centerLabel, centerSub,
}: {
  segments: DonutSeg[];
  size?: number;
  centerLabel?: string | number;
  centerSub?: string;
}) {
  const [active, setActive] = useState<number | undefined>(undefined);
  const data = segments.filter(s => s.value > 0);
  const total = data.reduce((a, s) => a + s.value, 0);

  if (total === 0) return null;

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data} dataKey="value" nameKey="name"
            cx="50%" cy="50%"
            innerRadius={size * 0.33} outerRadius={size * 0.46}
            paddingAngle={2} cornerRadius={3}
            startAngle={90} endAngle={-270}
            activeIndex={active} activeShape={ActiveShape}
            onMouseEnter={(_, i) => setActive(i)}
            onMouseLeave={() => setActive(undefined)}
            isAnimationActive animationDuration={700}
          >
            {data.map((s, i) => (
              <Cell key={i} fill={s.color} stroke="none" className="cursor-pointer outline-none" />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      {(centerLabel != null) && (
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-[26px] font-extrabold text-night tabular leading-none">
            {active != null ? data[active].value : centerLabel}
          </span>
          {centerSub && (
            <span className="text-[11px] font-medium text-muted mt-1">
              {active != null ? data[active].name : centerSub}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
